var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgeRestriction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 64 64",
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.99,41.22h-4.43v-15.59h-3.83v-3.56h8.26v19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.21,35.67c0-2.05,1.07-3.61,2.9-4.51-1.39-.9-2.21-2.22-2.21-3.94,0-3.36,3.01-5.47,7.36-5.47s7.41,2.11,7.41,5.47c0,1.72-.82,3.06-2.24,3.94,1.86.93,2.93,2.46,2.93,4.51,0,3.58-3.25,5.88-8.09,5.88s-8.04-2.3-8.04-5.88ZM35.86,35.53c0-1.7-1.39-2.73-3.61-2.73s-3.56,1.04-3.56,2.73,1.37,2.76,3.56,2.76,3.61-1.07,3.61-2.76ZM35.26,27.41c0-1.53-1.2-2.41-3.01-2.41s-2.95.88-2.95,2.41c0,1.45,1.15,2.35,2.95,2.35s3.01-.9,3.01-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.09,25.33h3.53v4.65h4.76v3.34h-4.76v4.65h-3.53v-4.65h-4.73v-3.34h4.73v-4.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32,64C14.36,64,0,49.64,0,32S14.36,0,32,0s32,14.36,32,32-14.36,32-32,32ZM32,4.51c-15.16,0-27.49,12.33-27.49,27.49s12.33,27.49,27.49,27.49,27.49-12.33,27.49-27.49S47.16,4.51,32,4.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeRestriction);
export default __webpack_public_path__ + "static/media/ageRestriction.1822f7c87ab06e79c03c07d7ee19b6a8.svg";
export { ForwardRef as ReactComponent };